import { useEffect, useRef, useState } from 'react'

const THINKING_MESSAGES = [
  'Thinking...',
  'Brewing some ideas...',
  'Running the numbers...',
  'Sketching out a plan...',
  'Crunching the details...',
  'Exploring possibilities...',
  'Connecting the dots...',
  'According to my calculations...',
  'Consulting the blueprints...',
  'Arranging the components...',
  'Measuring twice, coding once...',
  'Aligning the pixels...',
  'Wrangling some data...',
  'Almost there...'
]

const ROTATION_INTERVAL_MS = 3000

/**
 * Cycles through a list of fun status messages while active.
 * Returns the static `override` when provided (e.g. a specific tool message),
 * otherwise rotates through THINKING_MESSAGES.
 *
 * @param {boolean} active - Whether to rotate messages
 * @param {string|null} override - Static message that takes precedence (e.g. tool status)
 */
export function useRotatingMessage (active, override) {
  const [index, setIndex] = useState(0)
  const intervalRef = useRef(null)

  useEffect(() => {
    if (!active || override) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
      setIndex(0)
      return
    }

    intervalRef.current = setInterval(() => {
      setIndex(prev => (prev + 1) % THINKING_MESSAGES.length)
    }, ROTATION_INTERVAL_MS)

    return () => clearInterval(intervalRef.current)
  }, [active, override])

  if (!active) return null
  if (override) return override
  return THINKING_MESSAGES[index]
}
